import { render } from "./FastCommentsForm.vue?vue&type=template&id=e479bffa&ts=true"
import script from "./FastCommentsForm.vue?vue&type=script&lang=ts"
export * from "./FastCommentsForm.vue?vue&type=script&lang=ts"

import "./FastCommentsForm.vue?vue&type=style&index=0&id=e479bffa&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__